import superMeta from '../_CAT_ROOT_MODULE/metaCatRootModuleNode.mjs'

export default {
    ...superMeta,
    moduleIdProp: 'fmId',
    moduleType: 'FM',
    name: '功能域',
    type: 'CAT_ROOT_FM',
}
